import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import 'Components/StarDeal/StarDealLabel.scss';
import 'Components/StarDeal/StarDealLogo.scss';


const StarDealLabel = ({ flipLabel }) =>
  <div className={`star-deal-label-container ${flipLabel ? 'flip-label' : ''}`}>
    <div className="d-flex">
      <div className="label-slash" />
      <div className="star-deal-label">
        <div className="stardeal-logo">
          <FormattedMessage id="stardeal.label" defaultMessage="Star Deal" />
        </div>
      </div>
    </div>
    <div className="label-triangle" />
  </div>;

StarDealLabel.propTypes = {
  flipLabel: PropTypes.bool,
};

StarDealLabel.defaultProps = {
  flipLabel: false,
};

export default StarDealLabel;
